import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useCart } from "../lib/cart";
import { API } from "../lib/store";

const slots = () => {
  const out = [];
  const d = new Date();
  d.setMinutes(Math.ceil(d.getMinutes() / 30) * 30 + 30, 0, 0);
  for (let i = 0; i < 12; i++) {
    out.push(d.toLocaleString("en-GB", { weekday: "short", hour: "2-digit", minute: "2-digit" }));
    d.setMinutes(d.getMinutes() + 30);
  }
  return out;
};

const field = "w-full rounded-xl border border-black/15 bg-[#FFFFFF] px-4 py-3 text-sm text-[#1C1917] placeholder:text-stone-500 focus:border-[#D62828] focus:outline-none";

export const CollectForm = ({ onDone }) => {
  const { items, clear } = useCart();
  const [times] = useState(slots);
  const [f, setF] = useState({ name: "", phone: "", pickup_time: times[0], notes: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API}/orders`, { ...f, items: items.map(({ sku, qty }) => ({ sku, qty })) });
      clear();
      onDone(r.data);
      toast.success("Order received", { description: `Reference ${r.data?.ref ?? ""}` });
    } catch (err) {
      toast.error("Couldn't place the order", { description: "Check your name and phone number, then try again." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-3" data-testid="guna-collect-form">
      <input required minLength={2} placeholder="Your name" value={f.name} onChange={set("name")} className={field} data-testid="guna-collect-form-name" />
      <input required type="tel" minLength={7} placeholder="Mobile number" value={f.phone} onChange={set("phone")} className={field} data-testid="guna-collect-form-phone" />
      <select value={f.pickup_time} onChange={set("pickup_time")} className={field} data-testid="guna-collect-form-time">
        {times.map((t) => <option key={t}>{t}</option>)}
      </select>
      <textarea rows={2} placeholder="Notes (optional)" value={f.notes} onChange={set("notes")} className={field} data-testid="guna-collect-form-notes" />
      <p className="text-xs text-stone-600">Pay in store when you collect. ID may be required for age-restricted items (Challenge 25).</p>
      <button disabled={busy} data-testid="guna-collect-submit-button"
        className="flex w-full items-center justify-center gap-2 rounded-full bg-[#D62828] py-4 text-sm font-semibold text-[#FFFFFF] transition-opacity disabled:opacity-60">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Reserve for collection
      </button>
    </form>
  );
};
